import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { initListImages } from '@reducers/uploadQueue';

const UploadQueue = (props) => {
  const { initListImages } = props;
  useEffect(() => {
    initListImages();
  }, []);

  return null;
};

export default connect(null, { initListImages })(UploadQueue);
